import { Portfolio } from "contorller/portfolio/types";
import { every } from "lodash";

export function isMesAvailable(portfolio: Portfolio): boolean {
  return every(portfolio.funds, (d) => d.fund.distribution === 1);
}
